"use client";

import React from "react";
import { Check, ArrowRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const realEstateSegments = [{
  id: "item-1",
  number: "01",
  title: "Logistics & Warehousing",
  valueProp: "We provide scalable workforce solutions for modern distribution centers, ensuring peak operational efficiency through skilled personnel and on-site management. Our approach minimizes downtime and maximizes throughput in high-velocity environments.",
  focusAreas: ["Last-Mile Delivery Support", "Inventory Management", "Shift Optimization", "Safety Compliance Audits"]
}, {
  id: "item-2",
  number: "02",
  title: "Construction & Infrastructure",
  valueProp: "Supporting large-scale infrastructure projects with certified labor and rigorous health and safety oversight. We help contractors meet tight deadlines while maintaining the highest standards of structural integrity and site security.",
  focusAreas: ["Heavy Equipment Operation", "Site Coordination", "Resource Scaling", "Technical Supervision"]
}, {
  id: "item-3",
  number: "03",
  title: "Manufacturing & Production",
  valueProp: "Streamlining assembly lines with specialized technical staff and flexible staffing models. Our database of vetted professionals allows your facility to adapt rapidly to seasonal demand and complex production cycles.",
  focusAreas: ["Assembly Line Support", "Quality Control Systems", "Technical Maintenance", "Production Planning"]
}, {
  id: "item-4",
  number: "04",
  title: "Renewable Energy",
  valueProp: "Driving the green transition by providing specialized teams for wind and solar installation projects. We manage the logistics of remote site deployment and ensure all workers hold the necessary environmental certifications.",
  focusAreas: ["Wind Turbine Installation", "Solar Array Setup", "Project Logistics", "Specialized Certification"]
}];
export default function RealEstate() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}